module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/u4gUYh/images/9781439646496.jpg?1684229397271",
      "alt": "This image is the cover for the book Capital Region Motorcycling, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Capital Region Motorcycling, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The early 20th century was a time of greatness and prosperity for New York�s Capital Region. Economically powerful cities like Albany and Schenectady were home to emergent companies that employed a growing population. This influx gave way to an abundance of stores and retail establishments that catered to newly settled residents. With the local economy experiencing unprecedented growth, people had discretionary income to be used for leisure activities, such as going to Proctor�s Theater or enjoying the sport of motorcycling. Capital Region Motorcycling reveals the many activities that were enjoyed by those who wished to participate or watch. Photographs of road tours, polo matches, hill climbs, field meets, scrambles, and short-track and ice racing are featured alongside stories of the Electric City Riders and Spitzies Roamers motorcycle clubs.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark A. Supley, Ron Hedger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mark A. Supley is a local motorcycle historian, restorer, and racer and an author who specializes in the history of motorcycling the Capital Region of New York State. He has won a national award for his restoration of a 1926 Harley Davidson that currently resides in the Motorcyclepedia Museum in Newburgh, New York. Ron Hedger is on the board of directors for the Saratoga Automobile Museum and is the president of the Eastern Motor Sports Press Association.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0